import { render, staticRenderFns } from "./UsersMobile.vue?vue&type=template&id=dd7e0bd8&"
import script from "./UsersMobile.vue?vue&type=script&lang=ts&"
export * from "./UsersMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports